import axios from 'axios';

import { BASE_URL_MAIN } from '../common/urls';
import { mainApi } from '../utils/api';

export type ImportIFSInput = {
  datasetId: number;
  orgId: number;
  data: FormData;
  projectId: number;
};

export type ImportExistingIFSInput = {
  datasetId: number;
  orgId: number;
  data: {
    input_file: number;
  };
  projectId: number;
};

export type GetIFSInputInput = {
  datasetId: number;
  projectId: number;
  orgId: number;
};

export type GenerateIFSInput = {
  datasetId: number;
  projectId: number;
  orgId: number;
};

export type GetDownloadIFSInput = {
  orgId: number;
  projectId: number;
  datasetId: number;
  fileId: number;
};

export type GetDownloadAllIFSInput = {
  orgId: number;
  projectId: number;
  datasetId: number;
};

const getIFS = ({ datasetId, orgId, projectId }: GetIFSInputInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/datasets/${datasetId}/ifs_schema/`
  );

const getDownloadIFSLink = async ({
  orgId,
  projectId,
  datasetId,
  fileId,
}: GetDownloadIFSInput) => {
  const api = axios.create({
    baseURL: BASE_URL_MAIN,
    withCredentials: true,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/octet-stream',
    },
  });

  return api.get(
    `organizations/${orgId}/projects/${projectId}/datasets/${datasetId}/input_files/${fileId}/download/`
  );
};

const getDownloadAllIFSLink = async ({
  orgId,
  projectId,
  datasetId,
}: GetDownloadAllIFSInput) => {
  const api = axios.create({
    baseURL: BASE_URL_MAIN,
    withCredentials: true,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/octet-stream',
    },
  });

  return api.get(
    `organizations/${orgId}/projects/${projectId}/datasets/${datasetId}/input_files/download_all_files/`
  );
};

const importIFS = ({ datasetId, orgId, data, projectId }: ImportIFSInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/datasets/${datasetId}/import_ifs/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

const importExistingIFS = ({
  datasetId,
  orgId,
  projectId,
  data,
}: ImportExistingIFSInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/datasets/${datasetId}/import_existing_ifs/`,
    data
  );

export {
  getIFS,
  importIFS,
  getDownloadIFSLink,
  getDownloadAllIFSLink,
  importExistingIFS,
};
